import React from "react"

import FileUpdateSubscription from "graphql/Storage/File/subscription/fileUpdate"
import {useSubscription} from "@apollo/client"
import ProgressBar from "react-bootstrap/ProgressBar"

import "./style.scss"

type FileDetailsProps = {
  File: any,
}

export const FileDetails = (props: FileDetailsProps) => {
  useSubscription(FileUpdateSubscription, {
    skip: !props?.File?.id,
    variables: {
      id: props?.File?.id
    }
  })

  const transferProgress = props?.File?.transferProgress || 0

  return <div className="file-details-container">
    <div className="file-transfer-heading"><span>{props?.File?.name || `Fichier ${props?.File?.id || ""}`}</span><strong>{Math.round(transferProgress)}%</strong></div>
    <ProgressBar now={transferProgress} aria-label="Progression du transfert" />
  </div>


}
